import React from "react";
import classNames from "classnames";
import { useTrans } from "../../../hooks";
import Checklist from "./Checklist";
import PropTypes from "prop-types";

export const SignupHeader = ({ title, subtitle, hideChecklist = false }) => {
  const { trans } = useTrans();

  return (
    <div className="signup-header">
      <div className="heading-container">
        <h1 className={classNames("title")}>
          {title || trans("Sign up to get the full Wattpad experience")}
        </h1>
        <p className={classNames("subtitle")}>
          {subtitle || trans("Read, write, and connect")}
        </p>
      </div>
      {!hideChecklist && <Checklist />}
    </div>
  );
};

SignupHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  hideChecklist: PropTypes.bool
};
